<template>
  <div>
      <div class="m-expert">
        <h3 class="m-expert__title is-size-2 is-uppercase">Главный эксперт</h3>
        <div class="m-expert__content">
            <ws-main-expert-card
              :isPending="isPending"
              :isMyDeCenter="isMyDeCenter"
              :exam="exam"
              :expert="mainExpert"
              showEmpty
            />
        </div>
      </div>
      <div class="m-expert">
        <h3 class="m-expert__title is-size-2 is-uppercase">Эксперты</h3>
        <div class="m-expert__content">
            <ws-lineal-expert-card-list
              :isPending="isPending"
              :isDeleteLoading="isDeleting"
              :exam="exam"
              :isMyDeCenter="isMyDeCenter"
              :expertsData="experts"
              showEmpty
              @onDeleteExpert='onDelete'
            />
        </div>
      </div>
      <div class="m-expert">
        <h3 class="m-expert__title is-size-2 is-uppercase">Технические эксперты</h3>
        <div class="m-expert__content">
            <ws-technical-expert-card
              :exam="exam"
              :isPending="isPending"
              :isMyDeCenter="isMyDeCenter"
              showEmpty
              :experts="technicalExperts"
              :isDeleting="isDeletingTechnicalExp"
              @onDeleteExpert='onDeleteTechnicalExpert'
            />
        </div>
      </div>
  </div>
</template>

<script>
import WsMainExpertCard from './WsMainExpertCard.vue'
import WsLinealExpertCardList from './WsLinealExpertCardList.vue'
import { mapActions } from 'vuex'
import WsTechnicalExpertCard from './WsTechnicalExpertCard.vue'

export default {
  name: 'WsExpertsList',
  components: { WsMainExpertCard, WsLinealExpertCardList, WsTechnicalExpertCard },
  props: {
    exam: {
      type: Object,
      default: () => ({})
    },
    isMyDeCenter: {
      type: Boolean,
      default: true
    },
    expert: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      experts: [],
      mainExpert: {},
      technicalExperts: [],
      isDeleting: false,
      isPending: false,
      isDeletingTechnicalExp: false
    }
  },
  watch: {
    exam: {
      // deep: true,
      immediate: true,
      async handler (exam) {
        if (exam) {
          const expertGuid = this.getExpertGuid()
          if (exam.technical_experts) await this.initTechnicalExperts(exam.technical_experts)

          if (exam.experts && exam.experts.length && !this.experts.length) await this.initExperts(exam.experts)
          if (expertGuid) this.initMainExperts()
        } else {
          this.experts = []
          this.mainExpert = {}
          this.technicalExperts = []
        }
      }
    }
  },
  methods: {
    ...mapActions('refbook/experts', {
      findExperts: 'find'
    }),
    ...mapActions('exams', ['update']),
    getTechnicalExperts (experts) {
      if (!experts || !experts.length) {
        return []
      }

      return experts.map(exp => ({
        ...exp,
        ...exp.user_info
      }))
    },
    async onDelete (guid) {
      this.isDeleting = true
      await this.update([
        this.exam.guid, {
          delete: [guid]
        }, '/experts'
      ])
      const expert = this.experts.find(expert => expert.guid === guid)
      this.experts.splice(this.experts.indexOf(expert), 1)
      this.isDeleting = false
    },
    async onDeleteTechnicalExpert (guid) {
      this.isDeletingTechnicalExp = true
      await this.update([
        this.exam.guid, { delete: [guid] }, '/technical-experts'
      ])
      this.technicalExperts = this.technicalExperts.filter(i => i.guid !== guid)
      this.isDeletingTechnicalExp = false
    },
    async initExperts (experts) {
      this.isPending = true
      const _experts = await this.findExperts({
        query: {
          guids: this.exam.experts && this.exam.experts.map(e => e.guid),
          competency_guid: this.exam.accred_comps.competency.guid,
          with_light_certificates: true
        }
      })

      this.experts = experts
        .filter((v, i, a) => a.findIndex(t => (t.guid === v.guid)) === i)
        .map(expert => {
          if (Array.isArray(_experts) && _experts.find(exp => exp.guid === expert.guid)) {
            const exp = _experts.find(exp => exp.guid === expert.guid)
            const userInfo = exp.user_info ? { ...exp.user_info } : {}

            Object.assign(expert, {
              ...userInfo,
              attestations: exp.attestations,
              certificates: exp.certificates,
              lineal_expert_role_status: exp.lineal_expert_role_status
            })
          }
          return expert
        })

      this.isPending = false
    },

    async initTechnicalExperts (experts) {
      this.isPending = true
      const _experts = await this.findExperts({
        query: {
          guids: this.exam.technical_experts.map(e => e.guid),
          with_light_certificates: true
        }
      })
      this.technicalExperts = experts
        .filter((v, i, a) => a.findIndex(t => (t.guid === v.guid)) === i)
        .map(expert => {
          if (Array.isArray(_experts) && _experts.find(exp => exp.guid === expert.guid)) {
            const exp = _experts.find(exp => exp.guid === expert.guid)
            const userInfo = exp.user_info ? { ...exp.user_info } : {}

            Object.assign(expert, {
              ...userInfo,
              attestations: exp.attestations,
              certificates: exp.certificates
            })
          }
          return expert
        })

      this.isPending = false
    },

    async initMainExperts () {
      this.isPending = true
      try {
        if (this.expert.competency === null) return
        const _mainExpert = await this.findExperts({
          query: {
            guids: [this.expert.guid],
            competency_guid: this.expert.competency.guid,
            with_light_certificates: true
          }
        })
        if (Array.isArray(_mainExpert) && _mainExpert.find(exp => exp.guid === this.expert.guid)) {
          const exp = _mainExpert.find(exp => exp.guid === this.expert.guid)
          const userInfo = exp.user_info ? { ...exp.user_info } : {}
          this.mainExpert = {
            ...this.expert,
            ...userInfo,
            attestations: exp.attestations,
            certificates: exp.certificates,
            lineal_expert_role_status: exp.lineal_expert_role_status
          }
        }
      } finally {
        this.isPending = false
      }
    },
    getExpertGuid () {
      const guid = this.expert.guid.replace(/^[0|-]+/g, '')
      if (guid.length > 0) {
        return this.expert.guid
      }
      return ''
    }
  }
}
</script>

<style>

</style>
